var exports = {
  "w": "x127c5a35--3b4de4--header",
  "z": "x127c5a35--3b4de4--header_title",
};

module.exports = exports;
